import Icon from '../../../components/AppIcon';

const BusinessHours = () => {
  const schedule = [
    { day: "Monday - Friday", hours: "7:00 AM - 6:00 PM", type: "regular" },
    { day: "Saturday", hours: "8:00 AM - 4:00 PM", type: "regular" },
    { day: "Sunday", hours: "Emergency Only", type: "emergency" },
    { day: "Public Holidays", hours: "Emergency Only", type: "emergency" }
  ];

  const currentDay = new Date()?.toLocaleDateString('en-US', { weekday: 'long' });

  return (
    <div className="bg-card rounded-lg p-6 md:p-8 shadow-sm border border-border">
      <div className="mb-6">
        <h2 className="font-headline font-bold text-xl md:text-2xl lg:text-3xl mb-2">
          Business Hours
        </h2>
        <p className="font-body text-sm md:text-base text-muted-foreground">
          Regular service hours with 24/7 emergency availability
        </p>
      </div>
      <div className="space-y-3 md:space-y-4 mb-6">
        {schedule?.map((item, index) => (
          <div
            key={index}
            className={`flex items-center justify-between p-4 rounded-lg transition-colors ${
              item?.day?.includes(currentDay)
                ? 'bg-primary/10 border-2 border-primary' :'bg-muted'
            }`}
          >
            <div className="flex items-center gap-3">
              <Icon
                name={item?.type === 'emergency' ? 'AlertCircle' : 'Calendar'}
                size={20}
                className={item?.type === 'emergency' ? 'text-accent' : 'text-primary'}
              />
              <span className="font-headline font-semibold text-sm md:text-base">
                {item?.day}
              </span>
            </div>

            <span
              className={`font-accent text-sm md:text-base font-semibold whitespace-nowrap ${
                item?.type === 'emergency' ? 'text-accent' : 'text-foreground'
              }`}
            >
              {item?.hours}
            </span>
          </div>
        ))}
      </div>
      <div className="space-y-4">
        <div className="bg-accent/10 rounded-lg p-4 border-l-4 border-accent">
          <div className="flex items-start gap-3">
            <Icon name="Clock" size={20} className="flex-shrink-0 text-accent mt-1" />
            <div className="flex-1 min-w-0">
              <h3 className="font-headline font-semibold text-base md:text-lg mb-1">
                24/7 Emergency Service
              </h3>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                We're always available for plumbing and electrical emergencies. Call <span className="font-accent font-semibold text-accent">082 793 5785</span> anytime.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} className="flex-shrink-0 text-primary mt-1" />
            <div className="flex-1 min-w-0">
              <h3 className="font-headline font-semibold text-base md:text-lg mb-1">
                After-Hours Service
              </h3>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                Non-emergency after-hours calls may incur additional call-out fees. Emergency situations receive immediate response regardless of time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessHours;